import { useState } from 'react';

import { Wrapper } from '@american-autonomy/ag-ui';

import Form from 'components/Form';
import FormErrors from 'components/FormErrors';
import CaptionText from 'components/text/CaptionText';
import HelperText from 'components/text/HelperText';

import useTranslation from './hooks/useTranslation';

import AssetModelSelector from './components/AssetModelSelector';
import ServiceIntervalFields from './components/ServiceIntervalFields';
import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ServiceIntervalsForm: FunctionComponent<Props> = ({
    assetModels,
    className = '',
    form,
    hasErrors = false,
    isEditable = true,
    isSaving = false,
    partsByAssetModelId,
    testId = TEST_ID,
    unavailableAssetModelIds = []
}) => {
    const { HELPER, INTERVALS_UNAVAILABLE, NO_PARTS, READ_ONLY } = useTranslation();

    const [selectedAssetModelId, setSelectedAssetModelId] = useState(assetModels[0]?.id ?? '');

    const {
        control,
        formState: { errors }
    } = form;

    const parts = partsByAssetModelId[selectedAssetModelId] ?? [];

    const helperText = isEditable ? HELPER : `${HELPER} ${READ_ONLY}`;

    const emptyText = unavailableAssetModelIds.includes(selectedAssetModelId)
        ? INTERVALS_UNAVAILABLE
        : NO_PARTS;

    return (
        <Form form={form}>
            <Wrapper className={`${className} ${styles.serviceIntervalsForm}`} testId={testId}>
                <AssetModelSelector
                    assetModels={assetModels}
                    onSelect={setSelectedAssetModelId}
                    selectedAssetModelId={selectedAssetModelId}
                />

                <HelperText text={helperText} />

                {parts.length > 0 ? (
                    <ServiceIntervalFields
                        control={control}
                        isDisabled={isSaving || !isEditable}
                        parts={parts}
                    />
                ) : (
                    <CaptionText text={emptyText} />
                )}

                {hasErrors && <FormErrors errors={errors} />}
            </Wrapper>
        </Form>
    );
};

export default ServiceIntervalsForm;
